// Module
var code = "<tr> <td colspan=6>No matching links found</td> </tr> ";
// Exports
module.exports = code;